import React, { useState } from "react";
import IncDecCounter from "components/ui-component/IncDecCounter";
import { formatCurrency, formatFrequency } from "utils/HelperFunctions";
import { PlanOption, SelectedProduct } from "types/subscriptionAndPlans";
import Skeleton from "react-loading-skeleton";

interface PlanCardProps {
  item: PlanOption;
  index: number;
  isSelected: boolean;
  quantity: number;
  isCurrentPlan: boolean;
  allowQuantityChange: boolean;
  onSelectPlan: (product: PlanOption, isSelected: boolean) => void;
  onUpdateQuantity: (id: string, value?: number) => void;
}

const PlanCard: React.FC<PlanCardProps> = ({
  item,
  index,
  isSelected,
  quantity,
  isCurrentPlan,
  allowQuantityChange,
  onSelectPlan,
  onUpdateQuantity,
}) => {
  const [isImgErr, setIsImgErr] = useState<boolean>(false);
  const [isImgLoad, setIsImgLoad] = useState<boolean>(false);

  return (
    <div
      key={index}
      className={`w-full lg:p-5 p-4 rounded-md border cursor-pointer h-full animate__animated animate__fadeIn ${
        isSelected ? "border-blue" : "border-strokePrimary"
      }`}
      onClick={() => {
        onSelectPlan(item, isSelected);
      }}
    >
      <div className="w-full flex justify-between items-start sm:flex-row flex-col sm:gap-0 gap-2">
        <div className="flex flex-col justify-center">
          <div className="flex gap-2 items-center text-txtParagraph lg:text-[22px] text-lg leading-[28.64px] font-medium transition-all ease-in-out duration-500">
            {item?.image_name && item?.image_path && !isImgErr ? (
              <>
                {!isImgLoad && <Skeleton width={26} height={26} />}
                <img
                  src={`${item?.image_path}`}
                  alt={item?.image_name}
                  className={`w-[26px] h-[26px] object-contain transition-all ease-in-out duration-500 ${
                    isImgLoad ? "opacity-100 block" : "opacity-0 hidden"
                  }`}
                  onError={(e) => {
                    setIsImgErr(true);
                  }}
                  onLoad={() => {
                    setIsImgLoad(true);
                  }}
                />
              </>
            ) : (
              <></>
            )}
            <span className="capitalize">{item?.name?.toLowerCase()}</span>
            {isCurrentPlan && (
              <span className="py-1 px-3 bg-iconBright text-sm text-white capitalize font-medium rounded-[30px]">
                Current plan
              </span>
            )}
          </div>
          <div className="lg:mt-2 mt-[6px]">
            <span className="lg:text-base text-sm font-bold text-txtPrimary">
              {formatCurrency(item?.price)}
            </span>{" "}
            <span className="text-txtSecondary lg:text-base text-sm">
              {formatFrequency(
                item?.schedule,
                item?.interval_custom_count,
                item?.interval_custom_selector,
              )}
            </span>
          </div>
          <div className="lg:mt-4 mt-3 lg:text-base text-sm text-txtSecondary">
            {item?.description?.replace("and", "|") ?? ""}
          </div>
        </div>
        <div>
          {allowQuantityChange && isSelected ? (
            <IncDecCounter
              label="Quantity"
              current={quantity}
              setCurrent={(value?: number) => {
                onUpdateQuantity(item?.id, value);
              }}
            />
          ) : (
            <div
              className={`border border-strokePrimary text-txtSecondary  py-2 lg:text-lg rounded-md 1xl:w-[150px] lg:w-[125px] w-[100px] lg:px-0 px-2 flex justify-center items-center`}
              onClick={() => {}}
            >
              <span className="flex justify-center items-center lg:gap-2 gap-1">
                {isSelected ? "Selected" : "Select"}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
